<template>
    <div class="project-cascader">
        <sd-sheet :show.sync="showSheet" :title="titleStr || $t('text.perfect_tyui')" close>
            <template v-if="type == 'normal'">
                 <div class="two-scroll">
                    <picker-scroll class="first" :index.sync="pickerIndex" :data="columns"></picker-scroll>
                    <picker-scroll class="second" :index.sync="pickerIndex2" :data="columns2"></picker-scroll>
                </div>
                <div class="picker-button normal">
                    <sd-button class="confirm" @click.native="apply()">{{$t('text.confirm')}}</sd-button>
                </div>
            </template>
            <template v-else-if="columns2.length == 0">
                <picker-scroll :index.sync="pickerIndex" :data="columns"></picker-scroll>
                <div class="picker-button"><sd-button @click.native="next()">{{$t('text.next')}}</sd-button></div>
            </template>
            <template v-else>
                <div class="two-scroll">
                    <picker-scroll class="first" :index.sync="pickerIndex2" :data="columns2"></picker-scroll>
                    <picker-scroll class="second" :index.sync="pickerIndex3" :data="columns3"></picker-scroll>
                </div>
                <div class="picker-button">
                    <sd-button class="back" plain @click.native="init()" v-if="!countryId">{{$t('text.back')}}</sd-button>
                    <sd-button class="confirm" @click.native="confirm()">{{$t('text.confirm')}}</sd-button>
                </div>
            </template>
            
        </sd-sheet>
    </div>
</template>

<script>
import sdSheet from "./sheet.vue";
import pickerScroll from "../base/picker-scroll.vue"
import string from "es6-iterator/string";
import Template from '../template.vue';

export default {
    name: "sd-cascader",
    components: { sdSheet, pickerScroll, Template },
    props: {
        show: Boolean,
        data: Array,
        title: String,
        type: String,
        countryId: Number | String,
        stateId: Number | String,
        cityId: Number | String,
    },
    data() {
        return {
            showSheet: this.show,
            
            pickerIndex: 0,
            pickerIndex2: null,
            pickerIndex3: null,
            columns: this.data,
            columns2: [],
            columns3: [],
            titleStr: this.title
        }
    },
    watch: {
        show(val) {
            this.showSheet = val;
            if(val) this.init();
        },
        showSheet(val) {
            this.$emit("update:show", val)
        },
        async pickerIndex2(val) {
            console.log('pickerIndex2', val);
            console.log('columns2', this.columns2);
            if(val == null) return;
            const item = this.columns2[this.pickerIndex2];
            this.pickerIndex3 = 0;
            if(!(item&&item.value)) return;
            await this.getCity(item.value);
            // this.columns3 = ((item.children && item.children.length)? item.children : [{
            //     name: "暂无城市",
            //     value: null
            // }]);
            console.log('columns3', this.columns3)
            if(this.cityId) {
                let index = this.columns3.findIndex(item => {
                    return item.value == this.cityId
                })
                this.pickerIndex3 = index>=0? index : 0;
            }
            console.log('pickerIndex3', this.pickerIndex3);
        },
        pickerIndex(val) {
            if(this.type == 'normal') {
                const item = this.columns[this.pickerIndex];
                this.pickerIndex2 = 0;
                this.columns2 = item.children;
            }
        },
        title(val) {
            this.titleStr = val;
        }
    },
    mounted() {
        this.show && this.init();
    },
    methods: {
        async init() {
            this.titleStr = this.title;
            this.columns = this.data;
            this.columns2 = [];
            this.pickerIndex2 = null;
            if(this.type !== 'normal') {
                await this.getCountry();
            }

            if(this.type == 'normal') {
                this.pickerIndex2 = 0;
                this.columns2 = this.columns[this.pickerIndex2].children;
            }else if(this.countryId) {
                console.log('countryId', this.countryId);
                let index = this.columns.findIndex(item => {
                    return item.value == this.countryId
                })
                this.pickerIndex = index;
                await this.next();
            }
        },

        async getCountry(){
            const res = await this.$apis.common.getCountryList();
            const records = (res.data && res.data.records) || [];
            this.columns = records.map(item => ({
                children: [],
                name: item.name,
                value: item.id,
                type: "country",
            }));
        },

        async getState() {
            let countryItem = this.columns[this.pickerIndex];
            let res = await this.$apis.common.getStateList({id: countryItem.value}).then(res => {
                countryItem.children = res.data.records
                this.columns2 = res.data.map(item => {
                    return {
                        ...item,
                        children: [],
                        name: item.name,
                        value: item.id,
                        type: "province",
                    };
                })
            })
        },

        async getCity() {
            let stateItem = this.columns2[this.pickerIndex2];
            let res = await this.$apis.common.getCityList({id: stateItem.value}).then(res => {
                stateItem.children = res.data.records
                this.columns3 = res.data.map(item => {
                    return {
                        ...item,
                        children: [],
                        name: item.name,
                        value: item.id,
                        type: "city",
                    };
                })
            })
        },
        
        async next() {
            console.log('pickerIndex', this.pickerIndex);
            console.log('columns', this.columns);
            const item = this.columns[this.pickerIndex];
            this.pickerIndex2 = 0;
            if(this.pickerIndex === -1) return;
            await this.getState(item.value);
            // this.columns2 = item.children;
            this.titleStr = this.$t('text.perfect_qsde');
            if(this.stateId) {
                let index = this.columns2.findIndex(item => {
                    return item.value == this.stateId
                })
                this.pickerIndex2 = index;
            }
        },

        confirm() {
            const country = this.columns[this.pickerIndex];
            const province = this.columns2[this.pickerIndex2];
            const city = this.columns3[this.pickerIndex3];
            const value = {};

            if(country) {
                value.country = {
                    name: country.name,
                    value: country.value,
                    type: country.type || 'country',
                };
            }
            if(province) {
                value.province = {
                    name: province.name,
                    value: province.value,
                    type: province.type || 'province',
                };
            }
            if(city && city.value != null) {
                value.city = {
                    name: city.name,
                    value: city.value,
                    type: city.type || 'city',
                };
            }

            this.$emit("confirm", value);
        },

        apply() {
            this.$emit("confirm", [this.columns[this.pickerIndex].id, this.columns2[this.pickerIndex2].id]);
        }
    }
}
</script>

<style lang="scss" scoped>
    .project-cascader {

        .two-scroll {
            display: flex;

            .first /deep/.item-scroll{
                margin-left: 20px;
            }
            
            .second /deep/.item-scroll {
                margin-right: 20px;
            }
        }

        .picker-button {
            display: flex;
            padding: 0 20px 20px;

            &.normal {
                padding: 20px;
                border-top: 1px solid rgba(0, 0, 0, 0.05);

                .confirm {
                    border-radius: 4px;
                }
            }

            .back {
                width: 120px;
                margin-right: 10px;
            }

            .confirm {
                flex: 1;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/cascader.vue